import { Stack, Typography } from '@mui/material';
import { AlternativeMedicineContext } from 'Context/AlternativeMedicine';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useContext } from 'react';

export const TreatmentTypeTitle = () => {
  const { formData } = useContext(AlternativeMedicineContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  return formData.treatmentType ? (
    <Stack
      flexDirection={'row'}
      width={'fit-content'}
      gap={'5px'}
      m={'10px auto'}
    >
      <Typography variant='body7'>{dictionary.theTreatmentType}</Typography>
      <Typography variant='body8' fontWeight={600}>
        {formData.treatmentType}
      </Typography>
    </Stack>
  ) : (
    <></>
  );
};
